import React from 'react';
import Card from '../common/Card';
import strategyData from '../../data/strategy.json';

const StrategyStatus = () => {
  const { name, isActive, parameters, todaySignals } = strategyData;

  return (
    <Card title="전략 상태">
      <div className="space-y-4">
        <div>
          <div className="text-sm text-gray-400">전략명</div>
          <div className="text-lg font-semibold">{name}</div>
        </div>

        <div>
          <div className="text-sm text-gray-400 mb-2">상태</div>
          <div className="flex items-center space-x-2">
            <div className={`w-3 h-3 rounded-full ${isActive ? 'bg-green-500' : 'bg-gray-500'}`}></div>
            <span>{isActive ? '활성' : '비활성'}</span>
          </div>
        </div>

        <div>
          <div className="text-sm text-gray-400 mb-2">파라미터</div>
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div>MA: {parameters.maShort}/{parameters.maLong}</div>
            <div>RSI: {parameters.rsiOversold}/{parameters.rsiOverbought}</div>
            <div>MACD: ({parameters.macdFast},{parameters.macdSlow},{parameters.macdSignal})</div>
          </div>
        </div>

        <div>
          <div className="text-sm text-gray-400 mb-2">오늘의 시그널</div>
          <div className="flex space-x-4 text-sm">
            <div>매수: <span className="text-red-500">{todaySignals.buy}회</span></div>
            <div>매도: <span className="text-blue-500">{todaySignals.sell}회</span></div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default StrategyStatus;
